import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { isInsideIntake } from 'src/pages/consumer/meal-plans/consts';
import { useZipCodeInput } from 'src/rebrand/useZipCodeInput';
import { FaLocationDot } from 'src/shared/design-system/FontAwesome';
import { useLocation } from 'src/shared/hooks/useLocation';
import { useTracker } from 'src/shared/hooks/useTracker';
import { useMealPlanIntakeStoreSelectors } from 'src/ztore/meal-plan-intake-store';
import { ModalType, StyledModal } from 'web-common/src/shared/design-system/components/Modal';
import { ZipCodeSelectionForm } from './ZipCodeSelectionForm';

const HEADING = (
  <>
    <FaLocationDot /> Enter your zip code
  </>
);
const SUB_HEADING = 'Let’s see who’s cooking in your area.';

interface ZipCodeSelectionModalProps {
  isShowing: boolean;
  isMealPlan?: boolean;
  redirectUrl?: string;
  redirectOnSubmit?: boolean;
  showCloseButton?: boolean;
  hide: () => void;
}

export const ZipCodeSelectionModal: React.FC<ZipCodeSelectionModalProps> = ({
  isShowing,
  redirectUrl,
  redirectOnSubmit,
  showCloseButton,
  isMealPlan,
  hide,
}) => {
  const tracker = useTracker();
  const location = useLocation();
  const { clearFormData } = useMealPlanIntakeStoreSelectors();
  const isInIntake = isInsideIntake(location);

  const onZipSubmit = (zip: string) => {
    tracker.track(ClientEvents.EXPLORE_ZIP_SUBMIT, { zip });
    // Mid-intake the store holds answers the user has not submitted yet, so it must survive a
    // zip change.
    if (!isInIntake) {
      clearFormData();
    }
    hide();
  };
  const { onSubmit, zipCode, cachedZipCode, onChange } = useZipCodeInput({
    redirectRoute: redirectUrl,
    isMealPlan,
    onZipSubmit,
    redirectOnSubmit,
  });

  return (
    <StyledModal
      adjustForKeyboard
      headerText={HEADING}
      modalType={ModalType.STANDARD}
      isShowing={isShowing}
      primaryButtonText={cachedZipCode ? 'Update' : 'Find shefs near you'}
      primaryDisabled={zipCode.length < 5}
      secondaryButtonText='Cancel'
      showCloseButton={showCloseButton}
      onAccept={onSubmit}
      onClose={hide}>
      <p className='mb-4 text-left text-base text-neutral-600'>{SUB_HEADING}</p>
      <div className='flex justify-center'>
        <ZipCodeSelectionForm zipCode={zipCode} onChange={onChange} onSubmit={onSubmit} />
      </div>
    </StyledModal>
  );
};
